import * as actionTypes from '../constants/ActionTypes';

export function addYard(yard) {
    return {
        type: actionTypes.ADD_YARD.REQUEST,
        yard,
    };
}

export function findYards(yard) {
    return {
        type: actionTypes.FIND_YARDS.REQUEST,
        yard,
    };
}

export function getYard(id) {
    return {
        type: actionTypes.GET_YARD.REQUEST,
        id,
    };
}



// WEBPACK FOOTER //
// ./app/actions/yards.js